import { Star } from 'lucide-react';

export const StarRating = ({ rating, onRate, readonly = false, size = 'md' }) => {
    const sizeClasses = {
        sm: 'w-4 h-4',
        md: 'w-5 h-5',
        lg: 'w-6 h-6',
    };

    const handleClick = (value) => {
        if (!readonly && onRate) {
            onRate(value);
        }
    };

    return (
        <div className="flex items-center gap-1" data-testid="star-rating">
            {[1, 2, 3, 4, 5].map((value) => (
                <button
                    key={value}
                    type="button"
                    onClick={() => handleClick(value)}
                    disabled={readonly}
                    className={`rating-star ${readonly ? 'cursor-default' : 'cursor-pointer'}`}
                    data-testid={`star-${value}`}
                >
                    <Star
                        className={`${sizeClasses[size]} ${
                            value <= rating
                                ? 'fill-scalimmo-gold text-scalimmo-gold'
                                : 'text-gray-300'
                        }`}
                    />
                </button>
            ))}
        </div>
    );
};
